import React, {useEffect, useRef, useState} from "react";
import {FaCopy, FaEllipsisVertical, FaLock, FaPen, FaTableColumns, FaTrash, FaUsers} from "react-icons/fa6";
import Button from "../../../components/button";

const BoardLibraryItem = ({board, onOpen, onEdit, onCopy, onDelete}) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const close = event => !menuRef.current?.contains(event.target) && setMenuOpen(false);
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);

    const handleKeyDown = event => {
        if (event.target !== event.currentTarget) return;
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onOpen();
        }
    };

    return (
        <article
            onClick={onOpen}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            className="group relative cursor-pointer rounded border border-transparent bg-slate-50 p-3 transition hover:border-blue-200 hover:bg-blue-50/50 focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-100"
        >
            <div className="flex min-w-0 flex-1 items-center justify-start gap-3 text-left">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-blue-100 text-lg text-blue-700"><FaTableColumns /></span>
                <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm font-semibold text-slate-700">{board.name}</span>
                    <span className="mt-0.5 flex items-center gap-1 text-[11px] text-slate-400">
                        {board.visibility === "shared" ? <><FaUsers /> Compartilhado com {board.sharedUsers.length}</> : <><FaLock /> Privado</>}
                    </span>
                </span>
            </div>

            {board.canAlter && <div ref={menuRef} onClick={event => event.stopPropagation()} onKeyDown={event => event.stopPropagation()} className="absolute right-2 top-2">
                <Button type="button" onClick={() => setMenuOpen(open => !open)} col="!h-7 !w-7 !border-0 !bg-transparent !p-0 !text-slate-400 !shadow-none hover:!bg-slate-200"><FaEllipsisVertical /></Button>
                {menuOpen && (
                    <div className="absolute right-0 top-8 z-30 w-40 overflow-hidden rounded-lg border border-slate-200 bg-white py-1 shadow-xl">
                        <Button type="button" onClick={() => { onEdit(); setMenuOpen(false); }} col="w-full !h-8 !justify-start !rounded-none !border-0 !px-3 !shadow-none"><FaPen /> Editar</Button>
                        <Button type="button" onClick={() => { onCopy(); setMenuOpen(false); }} col="w-full !h-8 !justify-start !rounded-none !border-0 !px-3 !shadow-none"><FaCopy /> Copiar</Button>
                        <Button type="button" target="danger" onClick={() => { onDelete(); setMenuOpen(false); }} col="w-full !h-8 !justify-start !rounded-none !border-0 !px-3 !shadow-none"><FaTrash /> Excluir</Button>
                    </div>
                )}
            </div>}
        </article>
    );
};

export default BoardLibraryItem;
